import { render } from "./PerformanceChartWh4.vue?vue&type=template&id=07dcec8f&ts=true"
import script from "./PerformanceChartWh4.vue?vue&type=script&lang=ts"
export * from "./PerformanceChartWh4.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__